import { DefaultService } from '@/services/DefaultService';

const server = 'cockpit-expenses';

export default class CockpitDespesasService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    getAll(filters) {
        return this._http
            .post(`${this._env}/${server}/charts.json`, filters, this._headers)
            .then((res) => res.body, this.handleError);
    }

    // usado pelo componente de chart
    getChartByTitulo(titulo, filters) {
        return this._http
            .post(`${this._env}/${server}/chart/${titulo}`, filters, this._headers)
            .then((res) => res.body, this.handleError);
    }
}
